export const APP_NAME = 'Recetas de amor';

